<div class="upper-space">
  <mat-radio-group class="inline upper-space">
    <mat-radio-button
      class="right-space"
      [checked]="subProject.withPlacement"
      (change)="setWithPlacement($event.value)"
      [value]="true"
      [disabled]="
        client &&
        project.id != null &&
        subProject.status !== STATUS.DRAFT.valueOf()
      "
      >Met Plaatsing
    </mat-radio-button>
    <mat-radio-button
      class="left-space"
      [checked]="!subProject.withPlacement"
      (change)="setWithPlacement($event.value)"
      [value]="false"
      [disabled]="
        client &&
        project.id != null &&
        subProject.status !== STATUS.DRAFT.valueOf()
      "
      >Zonder Plaatsing
    </mat-radio-button>
  </mat-radio-group>
</div>

<div class="upper-space" *ngIf="subProject.withPlacement">
  <placement-picker
    [inputProject]="project"
    [inputSubProject]="subProject"
    [inputProjectPlacement]="subProject.projectPlacement"
    [client]="client"
    [disabled]="
      client &&
      project.id != null &&
      subProject.status !== STATUS.DRAFT.valueOf()
    "
    (outputProject)="save.emit()"
    (higherFloorOptionSelected)="higherFloorOptionSelected = $event"
  >
  </placement-picker>
</div>

<div class="upper-space" *ngIf="!subProject.withPlacement">
  <textarea-input
    [placeholder]="'Gelieve hier meer info over de afhaling in te geven'"
    [initContent]="subProject.pickup.extraInfoPickup"
    [title]="'Afhaling'"
    [disabled]="
      client &&
      project.id != null &&
      subProject.status !== STATUS.DRAFT.valueOf()
    "
    [client]="client"
    (answer)="setPickupInfo($event)"
  ></textarea-input>
</div>
